import React, {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper, InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import {OptionModel} from '../../../../model'
import {getOptionById, getOptionFather} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {initValues} from '../../../../util/values/options'
import {useApplication} from '../../../../hooks'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_OPTION} from '../../../../util/Constants'
const Option: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {module, getModuleList} = useApplication()
  const [optionFather, setOptionFather] = useState<{value: string | number; label: string}[]>([])

  const getOptionList = async (id: any) => {
    try {
      const response = await getOptionFather(1, id)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id || '', label: item.nombre || ''}))
      setOptionFather(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }

  const getOptionByIdValues = async () => {
    const response = await getOptionById(currentTabItem.idToEdit)
    const data = response.data.data
    type OptionModelKeys = keyof OptionModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (fieldName === 'aplicacionId') {
            let valueProv = data[fieldName as OptionModelKeys]
            if (typeof valueProv === 'string') {
              setValue(fieldName, valueProv)
              getOptionList(valueProv)
            }
          } else if (data[fieldName as OptionModelKeys]) {
            setValue(fieldName, data[fieldName as OptionModelKeys])
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }
  useEffect(() => {
    getModuleList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getOptionByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleGetOptions = (val: any) => {
    let data = val ? val : ''
    setValue('padreId', '')
    getOptionList(data.value)
  }
  return (
    <ContentForm isEdit={false} title={TITLE_FORM_OPTION}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper
            labelText='Módulo'
            name='aplicacionId'
            data={module}
            onChangeValue={handleGetOptions}
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Formulario'
            name='nombre'
            textPlaceholder='Escribe la opción'
            required
          />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Menú principal' name='padreId' data={optionFather} />
        </div>
      </div>
    </ContentForm>
  )
}

export default Option
